export default __webpack_public_path__ + "static/media/circle_plus.95b64293.svg";